import styled from "styled-components";

import tutorialBg from './../../assets/images/static/tutorialBg.png';

export const StyledTutorialSection = styled.section``;

export const StyledHeroSection = styled.div`
  background: url(${tutorialBg}) no-repeat top center;
  background-size: cover;
  min-height: 1080px;
  position: relative;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    min-height: 830px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    min-height: 720px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    min-height: 660px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    min-height: 530px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    min-height: 440px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    min-height: 340px;
  }
`;

export const HeadingSection = styled.div`
  margin-left: 250px;
  padding-top: 290px;
  width: 400px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-left: 180px;
    padding-top: 220px;
    width: 340px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding-top: 200px;
    width: 310px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-left: 144px;
    padding-top: 180px;
    width: 250px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-left: 130px;
    padding-top: 150px;
    width: 230px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-left: 40px;
    padding-top: 120px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    width: 270px;
  }
`;

export const HeadingTitle = styled.h2`
  font-weight: normal;
  margin: 24px 0 32px;
  &:before, 
  &:after {
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      content: '';
      height: 36px;
      left: -20px;
      width: 3px;
    }
  }
  &:after {
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      top: 42px;
    }
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin: 20px 0 24px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin: 16px 0 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin: 12px 0 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin: 8px 0 12px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin: 4px 0 8px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    font-size: ${({theme}) => theme.fonts.lgSubHeading};
    line-height: ${({theme}) => theme.lineHeight.customHeight};
    margin: 4px 0 16px;
  }
`;

export const Strong = styled.strong`
  font-size: inherit;
`;

export const SubTitle = styled.h4``;

export const SearchSection = styled.div`
  margin-top: 32px;
  position: relative;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-top: 24px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-top: 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-top: 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-top: 12px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-top: 0;
  }
  svg {
    color: ${({theme}) => theme.colors.lighter};
    font-size: ${({theme}) => theme.fonts.smallSize};
    left: 18px;
    position: absolute;
    top: 24px;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      left: 15px;
      top: 18px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.smallerSize};
      left: 12px;
      top: 16px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      top: 13px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: ${({theme}) => theme.fonts.smallestSize};
      left: 8px;
      top: 12px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: ${({theme}) => theme.fonts.smallerSize};
      left: 16px;
      top: 16px;
    }
  }
`;

export const SearchInput = styled.input`
  border-radius: ${({theme}) => theme.radius.medium};
  border: 1px solid ${({theme}) => theme.colors.lighter};
  font-family: 'RubikRegular';
  height: 64px;
  outline: none;
  padding: 20px 46px;
  width: 100%;
  &::placeholder {
    color: ${({theme}) => theme.colors.lighter};
    font-family: 'RubikLight';
  }
  &:focus {
    border: 1px solid ${({theme}) => theme.colors.secondary};
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 56px;
    padding: 16px 40px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    border-radius: ${({theme}) => theme.radius.hdMedium};
    height: 48px;
    padding: 12px 36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    border-radius: ${({theme}) => theme.radius.normal};
    height: 42px;
    padding: 10px 32px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 40px;
    padding: 8px 28px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    border-radius: ${({theme}) => theme.radius.hdRound};
    height: 48px;
    padding: 12px 42px;
  }
`;

export const RingIllustration = styled.img`
  bottom: 252px;
  position: absolute;
  right: -78px;
  width: 156px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    bottom: 220px;
    right: -65px;
    width: 130px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    bottom: 160px;
    right: -55px;
    width: 110px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    right: -50px;
    width: 100px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    right: -42px;
    width: 85px;
  }
`;

export const VideoWrapper = styled.div`
  background-color: ${({theme}) => theme.colors.basic};
  border-radius: ${({theme}) => theme.radius.max};
  border: 1px solid ${({theme}) => theme.colors.light};
  box-shadow: 0 30px 30px #00000014;
  height: 780px;
  margin: 0 auto;
  padding: 40px;
  position: relative;
  top: -256px;
  width: 1400px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 700px;
    padding: 32px;
    top: -200px;
    width: 1220px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    border-radius: ${({theme}) => theme.radius.round};
    height: 600px;
    padding: 24px;
    top: -130px;
    width: 1060px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    height: 524px;
    padding: 20px;
    width: 900px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    border-radius: ${({theme}) => theme.radius.medium};
    height: 464px;
    padding: 16px;
    width: 800px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    border-radius: ${({theme}) => theme.radius.normal};
    height: 380px;
    margin-top: 40px;
    top: 0;
    width: 90%;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    border-radius: ${({theme}) => theme.radius.medium};
    height: 294px;
    width: 342px;
  }
`;

export const StyledVideo = styled.div`
  border-radius: ${({theme}) => theme.radius.max};
  height: 85%;
  overflow: hidden;
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    border-radius: ${({theme}) => theme.radius.round};
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    border-radius: ${({theme}) => theme.radius.medium};
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    border-radius: ${({theme}) => theme.radius.normal};
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    border-radius: ${({theme}) => theme.radius.medium};
    height: unset;
  }
  .video-react .video-react-video,
  .video-react .video-react-poster {
    border-radius: ${({theme}) => theme.radius.max};
    height: 85%;
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      border-radius: ${({theme}) => theme.radius.round};
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      border-radius: ${({theme}) => theme.radius.medium};
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      border-radius: ${({theme}) => theme.radius.normal};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      border-radius: ${({theme}) => theme.radius.medium};
      height: 90%;
    }
  }
  .video-react .video-react-big-play-button {
    background-color: #00000033;
    border-radius: 50%;
    border: none;
    font-size: 6.5em;
    height: 120px;
    left: 45%;
    line-height: 1.8em;
    top: 35%;
    width: 120px;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: 5em;
      height: 100px;
      line-height: 2em;
      width: 100px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      height: 90px;
      line-height: 1.8em;
      width: 90px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: 4.5em;
      height: 80px;
      width: 80px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: 4em;
      height: 70px;
      width: 70px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: 3.3em;
      height: 58px;
      left: 130px;
      top: 35%;
      width: 58px;
    }
  }
`;

export const CaptionTitle = styled.div`
  font-family: 'RubikRegular';
  font-size: ${({theme}) => theme.fonts.lgSubHeading};
  line-height: ${({theme}) => theme.lineHeight.dSectionHeight};
  margin-top: 30px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    font-size: ${({theme}) => theme.fonts.customTitle};
    line-height: ${({theme}) => theme.lineHeight.customHeight};
    margin-top: 24px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    font-size: ${({theme}) => theme.fonts.secondarySize};
    line-height: ${({theme}) => theme.lineHeight.subHeight};
    margin-top: 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    font-size: ${({theme}) => theme.fonts.defaultSize};
    line-height: ${({theme}) => theme.lineHeight.primaryHeight};
    margin-top: 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    font-size: ${({theme}) => theme.fonts.smallerSize};
    line-height: ${({theme}) => theme.lineHeight.smallerHeight};
    margin-top: 16px;
    margin-left: 4px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    font-size: ${({theme}) => theme.fonts.smallestSize};
    margin-left: 0;
  }
`;

export const StyledVideoCarousel = styled.section`
  margin-top: -172px;
  position: relative;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-top: -130px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-top: -70px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-top: 56px;
  }
`;

export const VideoTutorialSection = styled.div`
  margin: 0 auto;
  position: relative;
  width: 1460px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 1260px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 1110px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 960px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 840px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    width: 95%;
  }
  .react-multi-carousel-list {
    align-items: flex-start;
    position: static;
    height: 500px;
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      height: 430px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      height: 400px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      height: 340px;
    }
  }
  .react-multiple-carousel__arrow {
    border: 1px solid ${({theme}) => theme.colors.lighter};
    background-color: ${({theme}) => theme.colors.basic};
    left: unset;
    right: 140px;
    top: unset;
    bottom: -50px;
    z-index: 9;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      bottom: 20px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      bottom: 80px;
      min-height: 36px;
      min-width: 36px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      bottom: 50px;
      min-height: 30px;
      min-width: 30px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      bottom: 60px;
      right: 60px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      bottom: 0;
      right: 60px;
    }
    &.react-multiple-carousel__arrow--right {
      right: 70px;
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        right: 80px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        right: 90px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.tab}) {
        right: 20px;
      }
    }
    &:before {
      color: ${({theme}) => theme.colors.border};
      font-weight: bold;
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        font-size: ${({theme}) => theme.fonts.smallerSize};
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        font-size: ${({theme}) => theme.fonts.smallestSize};
      }
    }
    &:hover {
      background-color: ${({theme}) => theme.colors.secondary};
      border: 1px solid ${({theme}) => theme.colors.secondary};
      &:before {
        color: ${({theme}) => theme.colors.basic};
      }
    }
  }
`;

export const Title = styled.h4`
  color: ${({theme}) => theme.colors.alternate};
  font-size: ${({theme}) => theme.fonts.lgTitleHeading};
  line-height: ${({theme}) => theme.lineHeight.lgTitleHeight};
  margin-left: 30px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    font-size: ${({theme}) => theme.fonts.hdSubHeading};
    line-height: ${({theme}) => theme.lineHeight.sectionHeight};
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    font-size: ${({theme}) => theme.fonts.lgSubHeading};
    line-height: ${({theme}) => theme.lineHeight.dSectionHeight};
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    font-size: ${({theme}) => theme.fonts.subTitle};
    line-height: ${({theme}) => theme.lineHeight.customHeight};
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    font-size: ${({theme}) => theme.fonts.customTitle};
    line-height: ${({theme}) => theme.lineHeight.subHeight};
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    font-size: ${({theme}) => theme.fonts.hdSubTitle};
    line-height: ${({theme}) => theme.lineHeight.primaryHeight};
  }
  &.secondTitle {
    margin-top: 100px;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      margin-top: 0;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      margin-top: -50px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      margin-top: -20px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      margin-top: 0;
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      margin-top: 56px;
    }
  }
`;

export const CarouselThumnail = styled.div`
  background-color: ${({theme}) => theme.colors.basic};
  border-radius: ${({theme}) => theme.radius.max};
  border: 1px solid ${({theme}) => theme.colors.light};
  box-shadow: 0 30px 30px #00000014;
  margin-top: 30px;
  margin-inline: 32px;
  padding: 28px;
  overflow: hidden;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-top: 24px;
    margin-inline: 28px;
    padding: 24px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    border-radius: ${({theme}) => theme.radius.round};
    margin-top: 20px;
    margin-inline: 24px;
    padding: 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    box-shadow: 0 10px 24px #00000014;
    margin-inline: 20px;
    padding: 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-inline: 16px;
    margin-top: 24px;
  }
`;

export const VideoSection = styled.div`
  align-items: center;
  background-color: ${({theme}) => theme.colors.$light};
  border-radius: ${({theme}) => theme.radius.normal};
  display: flex;
  height: 240px;
  margin-bottom: 28px;
  overflow: hidden;
  & .video-react.video-react-fluid, 
  & .video-react.video-react-16-9, 
  & .video-react.video-react-4-3 {
    background-color: ${({theme}) => theme.colors.$light};
    height: 240px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 210px;
    & .video-react.video-react-fluid, 
    & .video-react.video-react-16-9, 
    & .video-react.video-react-4-3 {
      height: 210px;
    }
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 180px;
    & .video-react.video-react-fluid, 
    & .video-react.video-react-16-9, 
    & .video-react.video-react-4-3 {
      height: 180px;
    }
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-bottom: 20px;
    height: 160px;
    & .video-react.video-react-fluid, 
    & .video-react.video-react-16-9, 
    & .video-react.video-react-4-3 {
      height: 160px;
    }
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
  }
  .video-react .video-react-poster {
    background-color: ${({theme}) => theme.colors.light};
  }
  .video-react .video-react-big-play-button {
    background-color: #00000033;
    border-radius: 50%;
    border: none;
    font-size: 4.2em;
    line-height: 1.75em;
    height: 72px;
    left: calc(60% - 72px);
    top: calc(70% - 72px);
    width: 72px;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: 3.5em;
      height: 62px;
      width: 62px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: 3em;
      line-height: 1.85em;
      height: 56px;
      left: calc(65% - 72px);
      top: calc(75% - 72px);
      width: 56px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: 2.5em;
      line-height: 2em;
      height: 48px;
      left: 100px;
      top: 55px;
      width: 48px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      left: 45%;
      top: 40%;
    }
  }
`;

export const VideoDetails = styled.div`
  font-family: 'RubikRegular';
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    line-height: ${({theme}) => theme.lineHeight.smallerHeight};
  }
`;

export const LoadMoreBtn = styled.div`
  color: ${({theme}) => theme.colors.secondary};
  cursor: pointer;
  font-family: 'RubikRegular';
  font-size: ${({theme}) => theme.fonts.hdSubTitle};
  margin: 100px auto;
  width: fit-content;
  &:hover {
    color: ${({theme}) => theme.colors.primary};
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    font-size: ${({theme}) => theme.fonts.defaultSize};
    margin: 60px auto;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    font-size: ${({theme}) => theme.fonts.smallSize};
    margin: 0 auto;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    font-size: ${({theme}) => theme.fonts.smallerSize};
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    font-size: ${({theme}) => theme.fonts.smallestSize};
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    position: relative;
    top: 50px;
  }
`;

export const DotsImg = styled.img`
  bottom: 240px;
  left: 10px;
  position: absolute;
  width: 130px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 110px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    left: 5px;
    width: 100px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 85px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    bottom: 200px;
    left: 0;
    width: 72px;
  }
`;
